import { graphql } from "gql";

const GET_ORGANIZATION_POLICIES = graphql(`
  query GetOrganizationPoliciesAtOrganization($organizationId: String!) {
    organization(organizationId: $organizationId) {
      daysUntilItBreaks
      inactivityPeriod
      maxAcceptanceDays
      maxAcceptanceSeverity
      maxNumberAcceptances
      minAcceptanceSeverity
      minBreakingSeverity
      name
      stakeholderRole
      vulnerabilityGracePeriod
    }
  }
`);

const GET_FINDINGS_POLICIES = graphql(`
  query GetFindingsPolicies($organizationId: String!) {
    organization(organizationId: $organizationId) {
      __typename
      name
      stakeholderRole
      findingPolicies {
        id
        __typename
        lastStatusUpdate
        name
        status
        tags
        treatmentAcceptance
      }
    }
  }
`);

const GET_POLICIES = graphql(`
  query GetPoliciesAtOrganization(
    $after: String
    $first: Int!
    $organizationId: String!
  ) {
    organization(organizationId: $organizationId) {
      __typename
      daysUntilItBreaks
      inactivityPeriod
      maxAcceptanceDays
      maxAcceptanceSeverity
      maxNumberAcceptances
      minAcceptanceSeverity
      minBreakingSeverity
      name
      vulnerabilityGracePeriod
      groupsConnection(after: $after, first: $first) {
        edges {
          node {
            __typename
            daysUntilItBreaks
            maxAcceptanceDays
            maxAcceptanceSeverity
            maxNumberAcceptances
            minAcceptanceSeverity
            minBreakingSeverity
            name
            vulnerabilityGracePeriod
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
`);

const UPDATE_ORGANIZATION_POLICIES = graphql(`
  mutation UpdateOrganizationPolicies(
    $daysUntilItBreaks: Int
    $inactivityPeriod: Int
    $maxAcceptanceDays: Int
    $maxAcceptanceSeverity: Float
    $maxNumberAcceptances: Int
    $minAcceptanceSeverity: Float
    $minBreakingSeverity: Float
    $organizationId: String!
    $organizationName: String!
    $vulnerabilityGracePeriod: Int
  ) {
    updateOrganizationPolicies(
      daysUntilItBreaks: $daysUntilItBreaks
      inactivityPeriod: $inactivityPeriod
      maxAcceptanceDays: $maxAcceptanceDays
      maxAcceptanceSeverity: $maxAcceptanceSeverity
      maxNumberAcceptances: $maxNumberAcceptances
      minAcceptanceSeverity: $minAcceptanceSeverity
      minBreakingSeverity: $minBreakingSeverity
      organizationId: $organizationId
      organizationName: $organizationName
      vulnerabilityGracePeriod: $vulnerabilityGracePeriod
    ) {
      success
    }
  }
`);

const UPDATE_GROUPS_POLICIES = graphql(`
  mutation updateGroupsPolicies(
    $daysUntilItBreaks: Int
    $groups: [String!]!
    $maxAcceptanceDays: Int
    $maxAcceptanceSeverity: Float
    $maxNumberAcceptances: Int
    $minAcceptanceSeverity: Float
    $minBreakingSeverity: Float
    $organizationId: String!
    $vulnerabilityGracePeriod: Int
  ) {
    updateGroupsPolicies(
      daysUntilItBreaks: $daysUntilItBreaks
      groups: $groups
      maxAcceptanceDays: $maxAcceptanceDays
      maxAcceptanceSeverity: $maxAcceptanceSeverity
      maxNumberAcceptances: $maxNumberAcceptances
      minAcceptanceSeverity: $minAcceptanceSeverity
      minBreakingSeverity: $minBreakingSeverity
      organizationId: $organizationId
      vulnerabilityGracePeriod: $vulnerabilityGracePeriod
    ) {
      success
    }
  }
`);

export {
  GET_ORGANIZATION_POLICIES,
  UPDATE_ORGANIZATION_POLICIES,
  GET_POLICIES,
  GET_FINDINGS_POLICIES,
  UPDATE_GROUPS_POLICIES,
};
